import { Profile } from '@zapier/shared-entities';

export default function shouldRouteToMyZaps(state) {
  const currentProfile = Profile.selectors.all.currentProfile(state);

  return (
    Profile.selectors.isSwitchOn('new_my_zaps_page_opt-in', currentProfile) &&
    !Profile.selectors.isSwitchOn('new_my_zaps_page_opt-out', currentProfile)
  );
}
